/*
Componente para crear Solicitudes de credito
Autor: Benjamín León
Fecha: 2024-27-11
*/
import Vehicle from '../interfaces/Vehicle'
import Client from '../interfaces/Client'

import CreditEdit from './CreditEdit'

const CreditCreaPage: React.FC<{ vehicle: Vehicle; client: Client }> = ({ vehicle, client }) => {
  return (
    <CreditEdit
      vehicle={vehicle}
      client={client}
      modificaSw={false}
      vehicleId={vehicle._id}
      clientId={client._id}
      dealId=""
    />
  )
}
export default CreditCreaPage
